import React, { useState } from 'react'
import Select from 'react-select';
import "./index.css"
import { useField } from 'formik';


const CustomSelect = ({ label, options, inputClass, onChange, name, value, checkForCheckoutPage, ...props }) => {
    const [selectedOption, setSelectedOption] = useState(null);
    const [field, meta] = useField({ name, ...props });

    const customStyles = {
        control: (base, state) => ({
            ...base,
            padding: "2px",
            border: "1px solid #ddd",
            placeholder: "px",
            borderLeft: `3px solid ${inputClass ? meta.touched && meta.error ? "#dc3545" : "#008bd2" : ""}`,
            borderColor: meta.touched && meta.error ? "#dc3545" : base.borderColor,
            boxShadow: meta.touched && meta.error ? "0 0 0 1px #dc3545" : base.boxShadow,
            "&:hover": {
                // borderColor: meta.touched && meta.error ? "#dc3545" : "#008bd2", // Explicitly define hover color
            },
        }),
        placeholder: (base) => ({
            ...base,
            fontSize: "12px", // Increase placeholder font size
            color: "#888", // Optional: Change color
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isSelected ? "#FFF" : state.isFocused ? "#FFF" : "#FFF", // Default React-Select colors
            color: state.isSelected ? "#000" : "#000", // Default text colors
            fontSize: "12px",
            "&:hover": {
                backgroundColor: "#EAF4FF", // Default hover color
                color: "#000", // Text color on hover
            },
        }),
    };


    return (
        <div className='custom_select' >
            <label>{label}</label>
            <Select
                {...field}
                // defaultValue={selectedOption}
                value={value && options.filter((option) => option.label === value)}
                onChange={onChange}
                placeholder={`Select a ${label}`}
                options={options}
                styles={customStyles}
                isDisabled={checkForCheckoutPage}
            />
            {meta.touched && meta.error && (
                <span className="error-message">{meta.error}</span>
            )}
        </div>

    )
}

export default CustomSelect